var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fusioncharts',{ref:"fc",attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataFormat":_vm.dataFormat,"dataSource":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }